import {NavigationService} from "../../Services/NavigationService";
import {StateParams} from "angular-ui-router";
import {TimeEntryDialog} from "../../Models/time-entry-dialog";
import {EKind, ETransmissionUnit, ITimeBookingDetailVm, ITimeEntryTypeVm} from "../../Data/Data";
import {AbsenceDataService} from "../../Services/AbsenceDataService";
import {Triarc} from "../../../Cirrus/utils/CommonUtils";
import {TimeEntryDataService} from "../../Services/TimeEntryDataService";
import {DateController} from "../../Models/date-controller";
import {Form} from "../../Models/form";
import {SaveDialog} from "../../Models/save-dialog";
import {DeleteDialog} from "../../Models/delete-dialog";
import {IPromise} from "angular";

export class AbsenceDetailController extends DateController {
  static controllerId = "AbsenceDetailController";
  static $inject = [
    '$scope',
    '$stateParams',
    NavigationService.serviceId,
    TimeEntryDataService.serviceId,
    AbsenceDataService.serviceId,
  ];

  private readonly userId: number;
  private readonly absenceId: string;

  form = new Form();
  formDisabled = false;

  loading = true;
  showTimeRange = false;

  timeEntryKind = EKind.Absence;
  timeEntry: ITimeEntryTypeVm;
  halfDay: boolean = false;

  absence: ITimeBookingDetailVm;

  deleteDialog = new DeleteDialog();
  saveDialog = new SaveDialog();
  timeEntryDialog = new TimeEntryDialog();

  constructor(private $scope: ng.IScope,
              $stateParams: StateParams,
              private navigation: NavigationService,
              private timeEntryData: TimeEntryDataService,
              private absenceData: AbsenceDataService) {
    super($scope);

    this.userId = $stateParams['userId'];
    this.absenceId = $stateParams['absenceId'] || null;

    if (this.isNew) {
      this.absence = <ITimeBookingDetailVm>{
        id: Triarc.generateGuid(),
        employee: {id: this.userId, externalId: null, label: ''},
        employeeId: this.userId,
      };
      this.loading = false;
    } else {
      this.absenceData.get(this.absenceId).then(absence => {
        this.absence = absence;
        this.date = this.absence.from;
        this.timeFrom = absence.from;
        this.timeTo = absence.to;
        this.timeEntryData.getEntryType(this.absence.timeEntryTypeId).then(timeEntry => {
          this.$scope.$apply(() => {
            this.timeEntry = timeEntry;
            this.loading = false;

            if (timeEntry.unit === ETransmissionUnit.Days) {
              // we can't edit these entries, they are split in days
              this.formDisabled = true;
            }
          });
        });
      });
    }

    this.form.add('date', () => this.date)
      .isRequired();

    this.form.add('timeFrom', () => this.absence.from)
      .isRequired()
      .isSmaller(() => {
        if (!this.showTimeRange) {
          this.calculateTime();
        }
        return this.absence.to
      });

    this.form.add('timeTo', () => this.absence.to)
      .isRequired()
      .isGreater(() => {
        if (!this.showTimeRange) {
          this.calculateTime();
        }
        return this.absence.from
      });

    this.form.add('timeEntry', () => this.absence.timeEntryType.id)
      .isRequired();

    this.$scope.$watch('ctrl.timeEntry', (val: ITimeEntryTypeVm) => {
      this.showTimeRange = !val || val.unit !== ETransmissionUnit.Days;
      if (this.showTimeRange) {
        this.timeFrom = this.absence.from;
        this.timeTo = this.absence.to;
      } else {
        this.calculateTime();
      }
    });

    this.$scope.$watch('ctrl.halfDay', () => {
      this.calculateTime();
    });
  }

  get isSameDay() {
    return this.absence.to && this.absence.from &&
      this.absence.to.getFullYear() === this.absence.from.getFullYear() &&
      this.absence.to.getMonth() === this.absence.from.getMonth() &&
      this.absence.to.getDate() === this.absence.from.getDate();
  }

  get isNew() {
    return this.absenceId === null || this.absenceId === undefined;
  }

  goBack() {
    this.navigation.goToState('absence-list', {userId: this.userId});
  }

  toggle(value: boolean) {
    this.halfDay = value;
  }

  isActive() {
    return this.halfDay;
  }

  calculate(date: Date, time: Date) {
    const newDate = new Date(date.getTime());
    newDate.setHours(time.getHours(), time.getMinutes(), 0, 0);
    return newDate;
  }

  openTimeEntryDialog() {
    this.timeEntryDialog.open(val => {
      this.timeEntry = val;
      this.absence.timeEntryType = {id: val.id, label: '', externalId: 0};
    })
  }

  save() {
    console.log('from', this.absence.from);
    console.log('to', this.absence.to);
    if (!this.form.isValid()) {
      return;
    }

    let factory: () => IPromise<any>;
    if (this.isNew) {
      factory = () => this.absenceData.create(this.absence);
    } else {
      factory = () => this.absenceData.save(this.absence);
    }

    this.saveDialog.open(factory).then(() => {
      this.goBack();
    });
  }

  delete() {
    const factory: any = () => this.absenceData.delete(this.absenceId);
    this.deleteDialog.open(factory).then(res => {
      if (res) {
        this.goBack();
      }
    });
  }

  fromChanged(date: Date): void {
    if (this.absence) {
      this.absence.from = date;
    }
  }

  toChanged(date: Date): void {
    if (this.absence) {
      this.absence.to = date;
    }
  }

  calculateTime() {
    if (this.absence.from) {
      this.absence.from.setHours(0, 0, 0, 0);
    }
    if (this.absence.to) {
      if (this.halfDay) {
        this.absence.to.setHours(12, 0, 0, 0);
      } else {
        this.absence.to.setHours(23, 59, 0, 0);
      }
    }
  }
}
